<!-- src/App.vue -->
<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import AnalyticsPage from "@/views/analytics/AnalyticsPage.vue";
export default {
  name: 'App',
  components:
    AnalyticsPage
};
</script>